import script from "./DeleteBusinessBtnContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteBusinessBtnContainer.vue?vue&type=script&setup=true&lang=js"

import "./DeleteBusinessBtnContainer.vue?vue&type=style&index=0&id=6952d42c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6952d42c"]])

export default __exports__